import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"close\"><title>close</title><rect width=\"20\" height=\"20\" opacity=\"0\" /><path d=\"M17.79,16.76h0L11,10l0,0,6.73-6.73a.72.72,0,0,0,0-1,.73.73,0,0,0-.51-.2h0a.73.73,0,0,0-.51.2L10,9l0,0L3.24,2.21a.72.72,0,1,0-1,1L9,10l0,0L2.21,16.76A.72.72,0,0,0,2.72,18h0a.72.72,0,0,0,.51-.2L10,11l0,0,6.73,6.73a.74.74,0,0,0,1,0,.72.72,0,0,0,0-1Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/close.svg
// module id = usbd
// module chunks = 264